import { useSetAtom } from 'jotai';
import { ReactNode, ReactPortal, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Flex } from '@optiaxiom/react';

import { globalOptiHeaderVisibleAtom } from '@frontend/atoms';

import { styles } from './Portal.css';

type PortalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
};

export function Portal({ isOpen, onClose, children }: PortalProps): ReactPortal | null {
  const setGlobalOptiHeaderVisible = useSetAtom(globalOptiHeaderVisibleAtom);

  useEffect(() => {
    if (isOpen) {
      setGlobalOptiHeaderVisible(false);
      document.body.style.overflow = 'hidden';
    } else {
      setGlobalOptiHeaderVisible(true);
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, setGlobalOptiHeaderVisible]);

  if (!isOpen) return null;

  // @ts-expect-error - TODO: fix this
  return createPortal(
    <Flex className={styles.portalOverlay} onClick={onClose}>
      <Flex
        className={styles.portalContent}
        onClick={e => e.stopPropagation()}
        flexDirection="column"
      >
        {children}
      </Flex>
    </Flex>,
    document.body
  );
}
